import React, { useState, useEffect, useContext } from 'react'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import { Button } from 'react-bootstrap'
import { CopyButton } from '../../components/Buttons/CopyButton.js'
import { NavigationContext } from '../../context/navigation-context'
import StatView from './StatView/StatView'


const Start = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()

  const { setHeaderData } = useContext(NavigationContext)

  useEffect(() => {
    setHeaderData({
      text: TRL_Pack.navbar.start
    });
  }, [])

  const clearSiteData = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };

  return (
    <>
      {sessionStorage.getItem('clientId') !== "console" ? <StatView /> : <></>}
      <div className='footer mt-4'>
        <h6>
          <span className="badge badge-secondary pe-none p-2 ml-2">Przydatne linki / informacje</span>

          <Button
            type="button"
            variant="btn-outline-primary"
            className="btn ml-2 mr-1 erase-btn"
            style={{ fontSize: "12px" }}
            onClick={clearSiteData}
          >
            Usuń pamięć podręczną
          </Button>
        </h6>

        <table className="table">
          <tbody>
            <tr>
              <td>
                <div className="text-primary">Retail 24 Dashboard 3.x (VD)</div>
                <div className="d-flex align-items-center">
                  <div className="text-success mr-2">https://portal.retail24.pl</div>
                  <CopyButton
                    value="https://portal.retail24.pl"
                    label=""
                    className="d-flex align-items-center mr-1 link-action-btn"
                  />
                  <Button
                    as="a"
                    href="https://portal.retail24.pl"
                    target="_blank"
                    rel="noreferrer"
                    variant="outline-primary"
                    size="sm"
                    className="link-action-btn"
                  >
                    <i className="fas fa-external-link-alt" />
                  </Button>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className="text-primary">Vendim Dashboard 2.0.4 (VD)</div>
                <div className="d-flex align-items-center">
                  <div className="text-success mr-2">https://vf.vendim.pl/vd</div>
                  <CopyButton
                    value="https://vf.vendim.pl/vd"
                    label=""
                    className="d-flex align-items-center mr-1 link-action-btn"
                  />
                  <Button
                    as="a"
                    href="https://vf.vendim.pl/vd"
                    target="_blank"
                    rel="noreferrer"
                    variant="outline-primary"
                    size="sm"
                    className="link-action-btn"
                  >
                    <i className="fas fa-external-link-alt" />
                  </Button>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className="text-primary">R24 Mobile 1.6.6.2</div>
                <div className="d-flex align-items-center">
                  <div className="text-success mr-2">https://play.google.com/store/apps/details?id=pl.retail24</div>
                  <CopyButton
                    value="https://portal.retail24.pl/dokumenty/R24_Mobile_latest.apk"
                    label=""
                    className="d-flex align-items-center mr-1 link-action-btn"
                  />
                  <Button
                    as="a"
                    href="https://portal.retail24.pl/dokumenty/R24_Mobile_latest.apk"
                    target="_blank"
                    rel="noreferrer"
                    variant="outline-primary"
                    size="sm"
                    className="link-action-btn"
                  >
                    <i className="fas fa-external-link-alt" />
                  </Button>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div className="text-primary">Retail 24 Shop 1.2 (VS)</div>
                <div className="text-success">
                  Aplikacja do obsługi zakupów na maszynach z płytą główną Retail 24 VMC
                  <br />
                  Kontakt w sprawie aktualizacji: serwis@retail24.pl
                </div>
              </td>
            </tr>

            <tr>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

export default Start;